<footer class="block align-bottom py-4">
  <div class="container mx-auto px-4">
    <hr class="mb-4 border-b-1 border-blueGray-200" />
    <div class="flex flex-wrap items-center md:justify-between justify-center">
      <div class="w-full md:w-4/12 px-4">
        <div class="text-sm text-blueGray-500 font-semibold py-1 text-center md:text-left">
          Copyright © {{ date }}
          <a class="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1">
            AtChurch
          </a>
        </div>
        <a href="https://mustardlabs.net" target="_blank" rel="noopener"
          class="flex items-center justify-center md:justify-start gap-1.5 py-1 text-xs text-blueGray-400 hover:text-blueGray-600">
          Powered by
          <img src="assets/brand/mustardlabs-logo.svg" alt="Mustard Labs" class="h-3.5 w-auto" />
        </a>
      </div>
      <div class="w-full md:w-8/12 px-4">
        <ul class="flex flex-wrap list-none md:justify-end justify-center">
          <li>
            <a href="https://atchurch.app/tnc"
              class="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="https://atchurch.app/privacy"
              class="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>